var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.294 10.779l2.929 2.928A1 1 0 005.93 14h4.142a1 1 0 00.707-.294l2.928-2.929A1 1 0 0014 10.07V5.928a1 1 0 00-.294-.707l-2.929-2.928A1 1 0 0010.07 2H5.928a1 1 0 00-.707.294L2.293 5.223A1 1 0 002 5.93v4.142a1 1 0 00.294.707zm1.515 4.342A3 3 0 005.93 16h4.142a3 3 0 002.121-.88l2.928-2.929A3 3 0 0016 10.07V5.928a3 3 0 00-.88-2.121L12.191.879A3 3 0 0010.07 0H5.928a3 3 0 00-2.121.88L.879 3.809A3 3 0 000 5.93v4.142a3 3 0 00.88 2.121l2.929 2.928z",
    fill: "#2C2D2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0yLjI5NCAxMC43NzkgMi45MjkgMi45MjhBMSAxIDAgMCAwIDUuOTMgMTRoNC4xNDJhMSAxIDAgMCAwIC43MDctLjI5NGwyLjkyOC0yLjkyOUExIDEgMCAwIDAgMTQgMTAuMDdWNS45MjhhMSAxIDAgMCAwLS4yOTQtLjcwN2wtMi45MjktMi45MjhBMSAxIDAgMCAwIDEwLjA3IDJINS45MjhhMSAxIDAgMCAwLS43MDcuMjk0TDIuMjkzIDUuMjIzQTEgMSAwIDAgMCAyIDUuOTN2NC4xNDJhMSAxIDAgMCAwIC4yOTQuNzA3em0xLjUxNSA0LjM0MkEzIDMgMCAwIDAgNS45MyAxNmg0LjE0MmEzIDMgMCAwIDAgMi4xMjEtLjg4bDIuOTI4LTIuOTI5QTMgMyAwIDAgMCAxNiAxMC4wN1Y1LjkyOGEzIDMgMCAwIDAtLjg4LTIuMTIxTDEyLjE5MS44NzlBMyAzIDAgMCAwIDEwLjA3IDBINS45MjhhMyAzIDAgMCAwLTIuMTIxLjg4TC44NzkgMy44MDlBMyAzIDAgMCAwIDAgNS45M3Y0LjE0MmEzIDMgMCAwIDAgLjg4IDIuMTIxbDIuOTI5IDIuOTI4eiIgZmlsbD0iIzJDMkQyRSIvPjxyZWN0IHg9IjQiIHk9IjciIHdpZHRoPSI4IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMkMyRDJFIi8+PC9zdmc+";
export { SvgNoads as ReactComponent };